module.exports = __webpack_public_path__ + "img/qiancai-back-people@2x.fe741d0e.png";